function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'white': 'rgb(235, 237, 241)','chambray': 'rgb(183, 204, 222)','ivory': 'rgb(234, 224, 209)','island-reef': 'rgb(177, 221, 207)','butter': 'rgb(235, 211, 152)','chalky-mint': 'rgb(155, 214, 212)','blossom': 'rgb(244, 201, 215)','orchid': 'rgb(205, 182, 208)','bay': 'rgb(165, 180, 173)','mustard': 'rgb(222, 183, 118)','moss': 'rgb(94, 109, 94)','grey': 'rgb(127, 128, 128)','blue-jean': 'rgb(96, 112, 148)','crimson': 'rgb(187, 76, 91)','espresso': 'rgb(98, 71, 63)','berry': 'rgb(129, 80, 109)','yam': 'rgb(195, 102, 70)','pepper': 'rgb(73, 74, 75)','navy': 'rgb(34, 51, 76)','black': 'rgb(42, 42, 45)','watermelon': 'rgb(238, 110, 123)','sapphire': 'rgb(65, 181, 220)','light-green': 'rgb(93, 138, 128)','brick': 'rgb(153, 61, 72)','blue-spruce': 'rgb(70, 100, 102)',};

    this.images = {};

    this.triggers = ['color',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
